import React, { useMemo } from 'react'
import ReactEcharts from "echarts-for-react";
import * as echarts from 'echarts';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

const ExitAnalysis = () => {
    //States
    const { exitAnalysis } = useSelector((state) => state.analyticsData)
    const { t, i18n } = useTranslation();

    //Options
    const exitSurveys = useMemo(() => {
        let data = []
        let graphData = []
        exitAnalysis?.forEach((que, index) => {
            data.push(index+1)
            graphData.push(que.exitData)
        })

        return {
            tooltip: {
                trigger: 'axis',
                axisPointer: {
                    type: 'shadow'
                }
            },
            xAxis: {
                type: 'category',
                name:  t('analytics.question'),
                nameLocation: 'middle',
                nameGap: 40,
                boundaryGap: false,
                data: data
            },
            yAxis: {
                type: 'value',
                name:  t('analytics.respondentCount'),
                nameLocation: 'middle',
                nameGap: 60,
            },
            series: [
                {
                    data: graphData,
                    type: 'line',
                    smooth: true,
                    symbol: 'circle',
                    symbolSize: 5,

                    itemStyle: {
                        color: '#E60000'
                    },
                    areaStyle: {
                        color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                            {
                                offset: 0,
                                // color: 'rgba(39, 115, 255,.8)',
                                color: 'rgba(230, 0, 0, .8)'

                            },
                            {
                                offset: 1,
                                color: 'rgba(230, 0, 0, .3)'
                            }
                        ])
                    },
                }
            ]
        }
    }, [i18n.language,exitAnalysis])


    return (
        <>
            <div className="card dashboard-card min-100">
                <div className="dashboard-card-header d-md-flex justify-content-between align-items-center">
                    <div className="left-wrap">
                        <h3>{t('analytics.exits_analysis')}

                        </h3>
                    </div>
                    {/* <div className="total-survey d-flex align-items-center">
                        Total survey 147 : Incomplete Survey 48
                    </div> */}
                </div>
                <div className="card-body">
                    <div className="chart-wrapper">
                        <ReactEcharts className='chart-height' option={exitSurveys} />
                    </div>
                </div>
            </div>
        </>
    )
}

export default ExitAnalysis